import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IBookingResponse, IUpgradeExchangeToPremium } from "../../Orchestrator/Types/Index";

export async function upgradeToPremium(upgradeExchangeToPremium: IUpgradeExchangeToPremium, bookingId: string, showLoader: boolean = true):
    Promise<IApiResponse<IBookingResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.bookingUpgradeToPremiumAPI(bookingId);

    return await apiRequest<IBookingResponse>(endpoint, 'POST', {
        body: JSON.stringify(upgradeExchangeToPremium),
    }, 'none', undefined, undefined, showLoader);
}